import { useEffect, useMemo, useState, FocusEvent } from 'react';
import { SERVICE_ALIAS, AUTOSUGGEST_ALIAS, ALIAS, SEARCH_PARAMS } from "@constants/index";
import { useAppSelector } from '@hooks/defineRtkTypedHook';
import { selectAlias } from '@features/ui/UiSlice';
import usePrevious from '@hooks/usePrevious';

interface IAutoSuggestProps {
    serviceAlias: string;
    suggestAlias: string;
    submitCallback: (clickKeyword: string) => void;
}

let autoSuggest = window.AutoSuggest ? new window.AutoSuggest() : null;
let isInitial = true;

export const getSuggestAlias = (serviceAlias: string, alias: string, searchParams: URLSearchParams) => {
    if(serviceAlias === SERVICE_ALIAS.AION) {
        switch(alias) {
            case ALIAS.GUIDEBOOK:
                return AUTOSUGGEST_ALIAS[ALIAS.GUIDEBOOK];
            case ALIAS.CHARACTER:
                return searchParams?.get(SEARCH_PARAMS.SEARCH_TYPE) ? AUTOSUGGEST_ALIAS['equipment'] : AUTOSUGGEST_ALIAS[ALIAS.CHARACTER];
            case ALIAS.LEGION:
                return AUTOSUGGEST_ALIAS[ALIAS.LEGION];
            case ALIAS.LEGION:
                    return AUTOSUGGEST_ALIAS[ALIAS.LEGION];
            default:
                return serviceAlias;
        }
    }

    if(serviceAlias === SERVICE_ALIAS.LINEAGE) {
        switch(alias) {
            case ALIAS.POWERBOOK:
                return AUTOSUGGEST_ALIAS[ALIAS.POWERBOOK];
            default:
                return serviceAlias;
        }
    }

    return serviceAlias;
};

const setAutoSuggest = (param: IAutoSuggestProps) => {
    const {serviceAlias, suggestAlias, submitCallback} = param || {};

    autoSuggest?.init({
        selector: '#autoSuggest',
        service: serviceAlias,
        alias: suggestAlias,
        size: 5,
        useDelbtn: true,
        submitCallback
    }, isInitial);

    if(isInitial) {
        isInitial = false;
    }
};

export const AutoSuggest = ({ serviceAlias, suggestAlias, submitCallback }: IAutoSuggestProps) => {
    useEffect(() => {
        setAutoSuggest({
            serviceAlias,
            suggestAlias,
            submitCallback
        });
    }, [suggestAlias]);
    
    return <div id="suggestWrap" className="suggest_wrap" data-name="suggest_wrap" data-suggest-alias={suggestAlias}>
        <div className="suggest_list" data-name="suggest_list">
            <div className="scroll" data-name="suggest_scroll"><ul></ul></div>
        </div>
    </div>;
};